import { useQuery } from "@tanstack/react-query"
import { usersReadUserMeOptions } from "@/heyapi/@tanstack/react-query.gen"

/**
 * Hook to get the current logged-in user's data
 */
export function useCurrentUser() {
  return useQuery({
    ...usersReadUserMeOptions(),
  })
}
